<template lang="html">
  <el-dialog
    title="添加装卸"
    v-if="dialogVisible"
    :visible="dialogVisible"
    @close="close"
    width="1000px"
  >
    <el-form
      ref="ruleForm"
      label-width="50"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      :validate-on-rule-change="false"
    >
      <handling-card
        ref="handlingCard"
        v-for="(value, key, index) in ruleForm"
        :key="index"
        :cardKey="0"
        :ruleForm="ruleForm"
        :rules="rules"
        @goodsDel="goodsDel"
        @addToCommonUse="addToCommonUse"
        @addGoodsSuccess="addGoodsSuccess"
        @addGoodsValidate="addGoodsValidate"
      />
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import handlingCard from "@/views/personal/deliver/components/handlingWrapper/components/handlingCard";
import { handlingMixins } from "@/views/personal/deliver/components/handlingWrapper/mixins/handlingMixins";

export default {
  mixins: [handlingMixins],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    close() {
      this.$emit("update:dialogVisible", false);
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$message.success({
            message: "装卸添加成功",
            duration: 2000
          });
          this.close();
          this.$emit("addHandlingSuccess", this.ruleForm);
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    dialogVisible(newVal) {
      newVal && this.initData();
    }
  },
  components: {
    handlingCard
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/components/addHandlingDialog/index.vue